import '/home/projects/mini/css/mini.css'

import { createApp } from 'vue'
import { registerSW } from 'virtual:pwa-register'
import App from './App.vue'
import router from './router'
import pinia from './stores/pinia'

registerSW({ immediate: true })

createApp(App)
  .use(pinia)
  .use(router)
  .mount('#app')
